import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/Profile-area');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Payment Cancelled - DISGENET</title>
        <meta name="description" content="Your payment was cancelled." />
      </Helmet>
      <CommonHeader />

      <div className="container mx-auto px-4 py-8 text-center">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8">
          <div className="mb-6">
            <i className="bi bi-x-circle-fill text-red-500 text-6xl"></i>
          </div>

          <h1 className="text-2xl font-bold text-gray-800 mb-4">Payment Cancelled</h1>

          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>

          <div className="space-y-4">
            <button
              onClick={handleRetry}
              className="btn-gradient-blue w-full py-3 px-6 rounded-lg font-semibold"
            >
              Try Again
            </button>

            <button
              onClick={handleGoHome}
              className="btn-gradient-pink w-full py-3 px-6 rounded-lg font-semibold"
            >
              Go to Home
            </button>
          </div>

          <p className="text-sm text-gray-500 mt-6">
            If you need help, please{' '}
            <a href="/Support" className="text-blue-500 hover:underline">
              contact our support team
            </a>
            .
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PaymentCancel;
